/** @format */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Card, CardContent } from '@material-ui/core';
import { Person, ExitToApp, ArrowRight } from '@material-ui/icons';
import { Avatar } from 'src/components/header/avatar';
import { Link } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { useSelector } from 'src/store';
import Breadcrumb from 'src/components/Breadcrumb';
// import { useState } from 'react';
// import Invoice from './invoice';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: 16
  },
  card: {
    background: '#f8f8f8',
    border: '1px solid #ababab',
    fontSize: '16px',
    color: '#333',
    minHeight: 250,
    position: 'relative',
    borderRadius: '1.6rem',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      minHeight: 280
    }
  },
  icon: {
    '& > span': {
      margin: theme.spacing(2)
    }
  },
  cardHead: {
    marginBottom: '15px',
    alignItems: 'center'
  },
  cardlink: {
    // position: 'absolute',
    // bottom: 15,
    color: '#234D96',
    marginTop: 'auto',
    cursor: 'pointer',
    textTransform: 'uppercase'
  },
  linkcolor: {
    color: '#234D96',
    fontSize: '2.5rem',
    verticalAlign: 'middle'
  }
}));

const Profile = props => {
  const { user } = useAuth();
  const { userProfile } = useSelector(state => state.users);
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const role = useMemo(() => {
    if (user && Object.keys(user).length > 0) {
      const { scenario, role, roleOther, roles } = user;
      if (roleOther) return roleOther;
      if (role) return t(`personalData.roles.${role}`);
      if (scenario) return t(`personalData.scenario.${scenario}`);
      if (roles && roles.length > 0) return roles[0];
      return 'Fleet Manager';
    }
    return '';
  }, [user, t]);

  return (
    <section className="main_content profile" lang={i18n.language}>
      <Breadcrumb data={[{ title: t('profile.title') }]} additionClassName="container-narrow" />

      <div className="container container-narrow">
        <h2 className="page_title">{t('profile.title')}</h2>
        {/* <h4 className="page_subtitle">{t('profile.subTitle')}</h4> */}

        <Grid container className={classes.root} spacing={4}>
          <Grid item xs={12} lg={6}>
            <CardContent className={classes.card}>
              <Grid container className={classes.cardHead} spacing={2}>
                <Grid item>
                  <Person fontSize="large" />
                </Grid>
                <Grid item>
                  <strong>{t('profile.Personaldata')}</strong>
                </Grid>
              </Grid>
              <Grid container spacing={4} alignItems="center">
                <Grid item>
                  <Avatar srcImg={userProfile?.picture || ''} name={`${user?.firstName} ${user?.lastName}`} />
                </Grid>
                <Grid item>
                  <p>{user && user.firstName && `${user?.firstName} ${user?.lastName}`}</p>
                  <span className="title">{role}</span>
                </Grid>
              </Grid>
              <Link to="/personaldata" className={classes.cardlink}>
                <ArrowRight className={classes.linkcolor} /> {t('profile.cta')}
              </Link>
            </CardContent>
          </Grid>
          {/* <Grid item xs={12} lg={6}>
                    <Card className={classes.card}>
                        <CardContent>
                        <Grid container className={classes.cardHead}>
                            <Grid item xs={1}>
                                <Business fontSize="large" color='primary' />
                            </Grid>
                            <Grid item xs={11}>
                                <strong>{t('profile.Companydata')}</strong>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                            </Grid>
                        </Grid>
                        <Link to="/companydata" className={classes.cardlink}><ArrowRight className={classes.linkcolor}/> {t('profile.cta')}</Link>
                        </CardContent>
                    </Card>
                </Grid> */}
          <Grid item xs={12} lg={6}>
            <CardContent className={classes.card}>
              <Grid container className={classes.cardHead} spacing={2}>
                <Grid item>
                  <ExitToApp fontSize="large" />
                </Grid>
                <Grid item>
                  <strong>{t('profile.Access')}</strong>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}></Grid>
              </Grid>
              <Link to="/access" className={classes.cardlink}>
                <ArrowRight className={classes.linkcolor} /> {t('profile.cta')}
              </Link>
              {/* <div className={classes.cardlink}><ArrowRight className={classes.linkcolor}/>{t('profile.cta')}</div> */}
            </CardContent>
          </Grid>
          {/* <Grid item xs={4}>
                    <Card className={classes.card}>
                        <CardContent>
                        <Grid container className={classes.cardHead}>
                            <Grid item xs={1}>
                                <VerticalSplit fontSize="large" color='primary' />
                            </Grid>
                            <Grid item xs={11}>
                                <strong>{t('profile.Licenses')}</strong>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                {t('profile.LicensesText')}
                            </Grid>
                        </Grid>
                        <div className={classes.cardlink}><ArrowRight className={classes.linkcolor}/>{t('profile.cta')}</div>
                        </CardContent>
                    </Card>
                </Grid> */}
          {/* <Grid item xs={12} lg={4}>
                    <Card className={classes.card}>
                        <CardContent>
                        <Grid container className={classes.cardHead}>
                            <Grid item xs={1}>
                                <VerticalSplit fontSize="large" color='primary' />
                            </Grid>
                            <Grid item xs={11}>
                                <strong>{t('profile.bills')}</strong>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12}>
                                {invoicesData ? <Invoice data={invoicesData} lang={i18n.language || 'en'} profileCard={true}/>:t('profile.billText')}
                                
                            </Grid>
                        </Grid>
                        </CardContent>
                    </Card>
                </Grid> */}
        </Grid>
      </div>
    </section>
  );
};

export { Profile };
